'use strict';

var _ = require('lodash');
var OverridesKeyService = function OverridesKeyService(overridesUtilsService) {
  var keysByDomain = {
    Leg: function Leg(row) {
      return {
        flightId: row.flightId,
        legId: row.legId
      };
    },
    LegCabin: function LegCabin(row) {
      return {
        flightId: row.flightId,
        legId: row.legId,
        legCabinId: row.legCabinId
      };
    },
    LegClass: function LegClass(row) {
      return {
        flightId: row.flightId,
        legId: row.legId,
        legCabinId: row.legCabinId,
        legClassId: row.legClassId
      };
    },
    SegmentClass: function SegmentClass(row) {
      return {
        flightId: row.flightId,
        segmentId: row.segmentId,
        segmentClassId: row.segmentClassId
      };
    },
    MarketDemandClassGroup: function MarketDemandClassGroup(row, fieldName) {
      var marketDemandClassGroup = {
        marketDemandId: row.marketDemandId,
        classGroup: row.classGroup,
        significantPOS: row.posName
      };
      if (fieldName !== 'seasonOverride') {
        marketDemandClassGroup.flowType = overridesUtilsService.getFlowType(fieldName);
      }
      return marketDemandClassGroup;
    },
    Service: function Service(row) {
      return {
        serviceId: row.serviceId
      };
    },
    ServiceClassPOS: function ServiceClassPOS(row, fieldName) {
      return {
        serviceId: row.serviceId,
        serviceClassId: row.serviceClassId + '.' + overridesUtilsService.getFlowType(fieldName),
        flowType: overridesUtilsService.getFlowType(fieldName)
      };
    },
    MarketClassPOSAverageFare: function MarketClassPOSAverageFare(row) {
      return {
        origin: row.origin,
        destination: row.destination,
        className: row.className,
        posName: row.spos,
        beginDate: row.applicableDateRangeBegin.toISOString(),
        endDate: row.applicableDateRangeEnd.toISOString()
      };
    },
    MarketClassPOSMappedFare: function MarketClassPOSMappedFare(row) {
      return {
        origin: row.origin,
        destination: row.destination,
        className: row.className,
        posName: row.pos,
        beginDate: row.applicableDateRangeBegin.toISOString(),
        endDate: row.applicableDateRangeEnd.toISOString()
      };
    },
    Fare: function Fare(row) {
      return {
        origin: row.origin,
        destination: row.destination,
        fareBasisCode: row.fareBasisCode,
        fareClass: row.bookingClass,
        faresSPOS: row.spos,
        beginDate: row.applicableDateRangeBegin.toISOString(),
        endDate: row.applicableDateRangeEnd.toISOString(),
        fareId: row.fareId,
        fareDirectionIndicator: row.fareDirectionIndicator
      };
    }
  };
  function buildOverrideKey(domain, row, field) {
    var overrideKey = keysByDomain[domain](row, field);
    setRtp(overrideKey, row, field);
    return overrideKey;
  }
  function setRtp(overrideKey, row, field) {
    var startRtpField = overridesUtilsService.getRtpField(field);
    if (startRtpField) {
      var rtpEdited = !_.isNil(row[startRtpField]) && _.has(row._old, startRtpField);
      overrideKey.startRtp = !_.isNil(row[startRtpField]) && rtpEdited ? row[startRtpField] : row.daysToDeparture;
    }
  }
  return {
    buildOverrideKey: buildOverrideKey
  };
};
OverridesKeyService.$inject = ['OverridesUtilsService'];
module.exports = OverridesKeyService;